import Swiper, { Navigation } from "swiper"
Swiper.use([Navigation])
export default new (class RecipesProductDetailCarousel {
    constructor() {
        this.sliderContainerSelector = "carousel-recipes-product-detail"
        this.sliderNextSelector = "carousel-recipes-product-detail-next"
        this.sliderPrevSelector = "carousel-recipes-product-detail-prev"
        this.handler()
    }

    handler() {
        const slider = document.querySelector(`.${this.sliderContainerSelector}`)

        if (!slider) return

        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        })
    }

    init() {
        document.querySelectorAll(`.${this.sliderContainerSelector}`).forEach((item) => {
            if (item.classList.contains('swiper-initialized')) return;
            new Swiper(item, {
                slidesPerView: 'auto',
                spaceBetween: 16,
                navigation: {
                    nextEl: item.parentElement.querySelector(`.${this.sliderNextSelector}`),
                    prevEl: item.parentElement.querySelector(`.${this.sliderPrevSelector}`),
                },
                centerInsufficientSlides: true,
                breakpoints: {
                    300: {
                        slidesPerView: 1.2,
                        spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: 'auto',
                        spaceBetween: 16,
                    },
                },
            })
        })
    }
})()
